module.exports = __webpack_public_path__ + "static/media/step-indicator-3.1f8a2cb0.svg";